import { faVideo } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button, Dialog, DialogCustomContent, Label } from '@playcastdotio/Shadcn';
import { Dispatch, SetStateAction, useContext } from 'react';
import { PlaycastContext } from '../PlaycastWrapper';

export const SettingsWarningModal = ({ state }: { state: [boolean, Dispatch<SetStateAction<boolean>>] }) => {
  const context = useContext(PlaycastContext);
  const [show, setShow] = state;

  const handleStopStream = () => {
    setShow(false);
    context.targetFunctions.stopStream();
  };

  return (
    <Dialog open={show}>
      <DialogCustomContent className='border-2 border-orange-600 bg-gray-800 gap-0 max-w-lg p-4'>
        <div className='flex text-center justify-center'>
          <div className='relative rounded-full p-4 border-4 border-red-600'>
            <FontAwesomeIcon icon={faVideo} className='size-14 text-red-600' />
            <div className='absolute flex text-white items-center bg-red-600 p-1 -right-10 top-0'>
              <div className='bg-white rounded-full p-2' />
              <Label className='pl-2'>LIVE</Label>
            </div>
          </div>
        </div>
        <div className='flex flex-col flex-1 justify-center text-center gap-4 pt-2'>
          <label className='text-3xl font-bold font-[Syne] text-orange-600'>You are Live</label>
          <div>
            <p className='text-white text-sm font-light'>Settings contains sensitive information</p>
            <p className='text-white text-sm font-light'>Please stop your session before entering</p>
          </div>
          <div className='flex flex-1 justify-around pt-2'>
            <Button className='m-0 bg-gray-400 hover:bg-gray-500 active:bg-gray-500 focus:bg-gray-500' onClick={handleStopStream}>
              Stop Stream
            </Button>
            <Button className='m-0 ' onClick={() => setShow(false)}>
              Go Back
            </Button>
          </div>
        </div>
      </DialogCustomContent>
    </Dialog>
  );
};

// const SettingsWarningModal = ({ state }: { state: [boolean, React.Dispatch<React.SetStateAction<boolean>>] }) => {
//     const [showSettingsWarning, setShowSettingsWarning] = state;
//     return (
//       <div className={clsx(showSettingsWarning ? 'fixed inset-0 z-50 bg-black/50' : 'hidden', 'flex justify-center items-center')}>
//         <div className='bg-gray-800 p-4 rounded-lg'>
//           <h2 className='text-white text-lg font-semibold'>Warning</h2>
//           <p className='text-white text-sm'>You cannot change settings while streaming. Please stop streaming to change settings.</p>
//           <Button
//             onClick={() => setShowSettingsWarning(false)}
//             className='bg-red-500 hover:bg-red-600 active:bg-red-500 focus:bg-red-500 text-white'
//           >
//             OK
//           </Button>
//         </div>
//       </div>
//     );
//   };
